import React from "react";

import Layout from "./components/Layout";
import "./styles/styles.css";

function App() {
  return (
    <div id="app">
      <Layout />
    </div>
  );
}

export default App;
